if (!customElements.get("common-media-banner")) {
  class commonMediaBanner extends HTMLElement {
    constructor() {
      super();
      this.swiperContainer = this.querySelector(".swiper");
    }
    connectedCallback() {
      this.initSwiper();
    }
    initSwiper() {
      let autoplayConfig = {};
      let autoplayDelay = Number(this.dataset?.autoplayInterval) || 4;
      let autoplaySpeed = Number(this.dataset?.autoplaySpeed) || 0.8;
      if (autoplayDelay !== 0) {
        autoplayConfig = {
          speed: autoplaySpeed * 1000,
          autoplay: {
            delay: autoplayDelay * 1000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
        };
      }
      this.swiper = new Swiper(this.swiperContainer, {
        loop: true,
        autoHeight:true,
        pagination: {
          el: this.querySelector(".swiper-pagination"),
          clickable: true,
        },
        ...autoplayConfig,
      });
      
      // 解决轮播图首次加载好自动播放时，第一个banner没有进度条的问题
      this.firstBannerPaginator = this.querySelector(".swiper-pagination-bullet:nth-child(1)");
      this.firstBannerPaginator.classList.remove("swiper-pagination-bullet-active");
      setTimeout(() => {
        this.firstBannerPaginator.classList.add("swiper-pagination-bullet-active");
      })
    }
  }

  customElements.define("common-media-banner", commonMediaBanner);
}
